import React from 'react';
import './input.css'
import { useState } from 'react';
import pic4 from '../../assets/pic4.png'
import pic5 from '../../assets/pic5.png'

const Inputtext = (props) => {

  const [showPassword, setShowPassword] = useState(false);

    const togglePassword = () => {
        setShowPassword(prev => !prev);
    };


    return ( 
        <fieldset className='container-input'>
            <label className='title-inputt' htmlFor={props.id}>
                {props.label}
            </label>
            <fieldset className='input-wrapper' >
            <input className='inputt'
            placeholder={props.placeholder}
              type={props.type === 'password' && !showPassword ? 'password' : 'text'}
            onChange={props.onChange}
            value={props.value}/>


            {props.type === 'password' && (
                    <span className='eye-icon' onClick={togglePassword}>
                                <img 
                                src={showPassword ? pic4 : pic5} 
                                alt="toggle password visibility"
                            />
                    </span>
                )}

</fieldset>
        </fieldset>
     );
}
 
export default Inputtext;